/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PropChallengeConditions } from './prop-challenge-conditions';
import { PropPackage } from './prop-package';

/**
 *
 * @export
 * @interface PropChallenge
 */
export class PropChallenge {
    /**
     *
     * @type {Array<PropPackage>}
     * @memberof PropChallenge
     */
    packages: Array<PropPackage>;
    /**
     *
     * @type {string}
     * @memberof PropChallenge
     */
    _id?: string;
    /**
     *
     * @type {string}
     * @memberof PropChallenge
     */
    type: PropChallengeTypeEnum;
    /**
     *
     * @type {string}
     * @memberof PropChallenge
     */
    iconName?: string;
    /**
     *
     * @type {boolean}
     * @memberof PropChallenge
     */
    autoApproved?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PropChallenge
     */
    acceptTermsAndCondition?: boolean;
    /**
     *
     * @type {string}
     * @memberof PropChallenge
     */
    promoCode?: string;
    /**
     *
     * @type {number}
     * @memberof PropChallenge
     */
    retryDiscountPercent?: number;
    /**
     *
     * @type {PropChallengeConditions}
     * @memberof PropChallenge
     */
    conditions: PropChallengeConditions;
}

/**
 * @export
 * @enum {string}
 */
export enum PropChallengeTypeEnum {
    Audition = 'audition',
    Funded = 'funded',
    Demo = 'demo',
}
